import { API_METHOD_CONSTANTS } from '../core';

export const PERMISSION_CONSTANT = {
  MasterModuleAttribute: 'MasterModuleAttribute',
  MasterRoleRight: 'MasterRoleRight',
  MasterRole: 'MasterRole',
  MasterPlan: 'MasterPlan',
  MobileVersion: 'MobileVersion',
};


export const PERMISSION_NGRX_CONSTANT = {
  [PERMISSION_CONSTANT.MobileVersion]: {
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      STATE: 'common',
      API_METHOD: 'getMobileVersionById',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'addMobileVersion',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Mobile Version',
      SUCCESS: 'Mobile Version Created Successfully',
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateMobileVersion',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Mobile Version',
      SUCCESS: 'Mobile Version Updated Successfully',
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getMobileVersionPagging',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getMobileVersionAll',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteMobileVersion',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Mobile Version',
      SUCCESS: 'Mobile Version Deleted Successfully',
    },
  },
  [PERMISSION_CONSTANT.MasterRoleRight]: {
    [API_METHOD_CONSTANTS.BULK_UPDATE]: {
      API_METHOD: 'addMasterRoleRightBulk',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Master Role Right',
      SUCCESS: 'Master Role Right Updated Successfully',
    },
  },
  [PERMISSION_CONSTANT.MasterRole]: {
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getMasterRole',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'addMasterRole',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Master Role',
      SUCCESS: 'Master Role Created Successfully',
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateMasterRole',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Master Role',
      SUCCESS: 'Master Role Updated Successfully',
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getMasterRolePagging',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getMasterRoleAll',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteMasterRole',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Master Role',
      SUCCESS: 'Master Role Deleted Successfully',
    },
  },

  [PERMISSION_CONSTANT.MasterPlan]: {
    [API_METHOD_CONSTANTS.GET_BY_ID]: {
      API_METHOD: 'getMasterPlanFeature',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.INSERT]: {
      API_METHOD: 'addMasterPlanFeature',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Master Plan',
      SUCCESS: 'Master Plan Created Successfully',
    },
    [API_METHOD_CONSTANTS.UPDATE]: {
      API_METHOD: 'updateMasterPlanFeature',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Master Plan',
      SUCCESS: 'Master Plan Updated Successfully',
    },
    [API_METHOD_CONSTANTS.BULK_UPDATE]: {
      API_METHOD: 'addOnlyMasterPlanFeature',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Master Plan',
      SUCCESS: 'Master Plan Features Saved Successfully',
    },
    [API_METHOD_CONSTANTS.GET_PAGGING]: {
      API_METHOD: 'getMasterPlanPagging',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getMasterPlanAll',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
    },
    [API_METHOD_CONSTANTS.DELETE]: {
      API_METHOD: 'deleteMasterPlanFeature',
      STATE: 'common',
      SUCCESS_NOTIFICATION: true,
      TITLE: 'Master Plan',
      SUCCESS: 'Master Plan Deleted Successfully',
    },
  },

  [PERMISSION_CONSTANT.MasterModuleAttribute]: {
    [API_METHOD_CONSTANTS.GET_ALL]: {
      API_METHOD: 'getMasterModuleAttributeAll',
      STATE: 'common',
      SUCCESS_NOTIFICATION: false,
      TITLE: '',
      SUCCESS: '',
    },
  },
};
